<p-button [text]="true" 
[icon]="estFavori ? 'pi pi-heart-fill' : 'pi pi-heart'" 
[severity]="estFavori ? 'danger' : 'secondary'"
(click)="ajouterFavori()"
[label]="estFavori ? 'Favori' : ''"
[pTooltip]="estFavori ? 'Pour retirer des favoris, cliquer sur le bouton favoris au haut de la page' : 'Ajouter aux favoris'" 
tooltipPosition="right"
id="btnFavori" ></p-button>